import { render, staticRenderFns } from "./TimeSlot.vue?vue&type=template&id=24949e98"
import script from "./TimeSlot.vue?vue&type=script&lang=js"
export * from "./TimeSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports